import React, { useState } from 'react';
import { Notification } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import { useTvsState } from '../../utils/useTvsState';
import './VerificationSuccessPage.css';

const VerificationSuccessPage: React.FC = () => {
  const { t } = useTranslation();

  const [isNotificationOpen, setIsNotificationOpen] = useState(true);
  const [, setTvState] = useTvsState();
  return (
    <>
      <div className='grid grid-flex grid-justify-center'>
        {isNotificationOpen && (
          <Notification
            className='verification-success-notification'
            title={t('VerificationSuccessPage.successHeading')}
            message={t('VerificationSuccessPage.successMessage')}
            type='success'
            variant='elevated'
            showCloseIcon
            onClose={() => {
              setIsNotificationOpen(false);
              setTvState('');
            }}
          />
        )}
      </div>
    </>
  );
};

export default VerificationSuccessPage;
